export default function getIsCurrentGroupCouncil(state: any) {
  return state.getIn(['currentGroup', 'data', 'type']) === 4;
}
